module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAKCAQAAADSxYyGAAAAEUlEQVR42mP8/58BCTAODi4AUdUT93F0M5kAAAAASUVORK5CYII="